// extracted by mini-css-extract-plugin
module.exports = {"Project_Activity_List":"ProjectActivityList_Project_Activity_List__Hw-MT","List_Scroll_Table":"ProjectActivityList_List_Scroll_Table__2R25t"};